import BlurLinearOutlined from "@mui/icons-material/BlurLinearOutlined";
import CalendarMonthOutlined from "@mui/icons-material/CalendarMonthOutlined";
import { Calendar } from "../../../../../styles/icons/calendar";
import { makeDefaultFilters } from "../../../../../utils/default-filters";
import { useSidebar2026 } from "../../../hooks/use-sidebar-2026";
import { useIsActive } from "../hooks/use-is-active";
import { Item } from "../item";
import { Section } from "../section";

import type { FC } from "react";

interface NavPlannerOptionsProps {
  onNavigate?: () => void;
}

export const NavPlannerOptions: FC<NavPlannerOptionsProps> = ({ onNavigate }) => (
  <Section title="Planner">
    <PlannerItems onNavigate={onNavigate} />
  </Section>
);

/** Calendar and Timeline: under their own heading in the original sidebar, in the main list in the 2026 one. */
export const PlannerItems: FC<NavPlannerOptionsProps> = ({ onNavigate }) => {
  const isActive = useIsActive();
  const sidebar2026 = useSidebar2026();

  const filters = makeDefaultFilters().toString();

  return (
    <>
      <Item
        title="Calendar"
        icon={sidebar2026 ? <CalendarMonthOutlined /> : <Calendar />}
        onClick={{ type: "href", value: `/calendars/schedule?${filters}` }}
        onNavigate={onNavigate}
        active={isActive("/calendars")}
      />
      <Item
        title="Timeline"
        icon={<BlurLinearOutlined />}
        onClick={{ type: "href", value: `/timeline/start_date?${filters}` }}
        onNavigate={onNavigate}
        active={isActive("/timeline", true)}
      />
    </>
  );
};
